<script>
import axios from 'axios';
import router from '@/router';
/*import logoutButton from './logout-button';*/
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

export default {
  page: {
    title: 'Volunteer System',
    meta: [
      {
        name: 'Volunteer System',
      },
    ],
  },
  components: { /*logoutButton ,*/ Header, Footer },
  data() {
    return {
      title: '',
      items: [
        {
          text: '',
          href: '/',
        },
      ],
      submitData: {
        user_type_id: '',
        status: 'applicant',
      },
      contactInfoForm: {},
      isDisable: true,
      isShow: false,
      selected: false,
      isAdditional: false,
      isOpportunities: false,
      isBackground: false,
      isEmployment: false,
      isFaith: false,
      isPersonalInfo: false,
      isQuestion: false,
      isReference: false,
      errors: [],
      applicationNotSubmitted: true,
      userStatus: null,
      enableConditions: true,
      userData: JSON.parse(localStorage.getItem('web_user')),
      userRoles: JSON.parse(localStorage.getItem('selectedRoles')),
    };
  },
  mounted() {
    this.getSubmitFormStats();
    console.log(this.applicationNotSubmitted);
  },
  created() {
    this.formSubmissionChecker();
    this.getContactDetail();
  },
  methods: {
    personalInformation() {
      router.push({ name: 'contact-info' });
    },
    questions() {
      router.push({ name: 'questions' });
    },
    backgroundCheck() {
      router.push({ name: 'background-check' });
    },
    faith() {
      router.push({ name: 'faith' });
    },
    references() {
      router.push({ name: 'references' });
    },
    employment() {
      router.push({ name: 'employment' });
    },
    additionalDetails() {
      router.push({ name: 'additional-details' });
    },
    opportunities() {
      router.push({ name: 'opportunities' });
    },
    submitApplication() {
      const userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: { Authorization: 'Bearer ' + userData['token'] },
      };
      if (userData['token']) {
        this.isDisable = true;
        this.submitData.user_type_id = userData['user_type_id'];
        axios
          .post('user/registration/submission', this.submitData, config)
          .then((res) => {
            if (res.status == 200) {
              this.isDisable = false;
              // if (userData['user_type_id'] == 4) {
              //   this.addAssignment();
              // }
              router.push({ name: 'thankyou' });
              // this.$bvModal.show('mentorApplicationComplete');
            }
          })
          .catch((err) => {
            if (err.response) {
              this.isDisable = false;
              this.isShow = true;
              this.errors = err.response.data.error.message;
            }
          });
      }
    },

    // Getting Current User Forms States
    getSubmitFormStats() {
      this.isAdditional = false;
      this.isBackground = false;
      this.isEmployment = false;
      this.isFaith = false;
      this.isPersonalInfo = false;
      this.isQuestion = false;
      this.isReference = false;
      this.isDisable = true;
      var userData = JSON.parse(localStorage.getItem('web_user'));
      var config = {
        headers: { Authorization: 'Bearer ' + userData['token'] },
      };
      if (userData.token) {
        axios
          .get(
            'user/registration/submitted-forms?user_type_id=' +
              userData['user_type_id'],
            config
          )
          .then((res) => {
            console.log('stats',res.data.response);
            if (res.data.response.additional_details) {
              this.isAdditional = true;
            }
            if (res.data.response.background) {
              this.isBackground = true;
            }
            if (res.data.response.employment) {
              this.isEmployment = true;
            }
            if (res.data.response.faith) {
              this.isFaith = true;
            }
            if (res.data.response.personal_info) {
              this.isPersonalInfo = true;
            }
            if (res.data.response.question) {
              this.isQuestion = true;
            }
            if (res.data.response.reference) {
              this.isReference = true;
            }
            if (res.data.response.opportunity) {
              this.isOpportunities = true;
            }

            if(this.userData.user_type_id === 4 && !this.userData.is_mentor){
            // if volunteer
              if(this.isPersonalInfo && this.isQuestion && this.isFaith && this.isOpportunities && this.isAdditional){               
                this.isDisable = false;
              }
            }else if(this.userData.user_type_id === 3 ){
            // if Mentor
              if(this.isPersonalInfo && this.isQuestion && this.isFaith && this.isReference && this.isAdditional && this.isBackground){
                this.isDisable = false;
              }
            }else if(this.userData.user_type_id === 4 && this.userData.is_mentor){
            // if Volunteer/Mentor
              if(this.isPersonalInfo && this.isQuestion && this.isFaith && this.isOpportunities && this.isAdditional && this.isBackground && this.isReference){
                this.isDisable = false;
              }
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
            }
          });
      }
    },
    formSubmissionChecker() {
      var config = {
        headers: { Authorization: 'Bearer ' + this.userData.token },
      };

      axios
        .get(
          `user/registration/registration-check?user_id=${this.userData.id}&user_type_id=${this.userData.user_type_id}`,
          config
        )
        .then((res) => {
          // console.log(res.data.response);
          if (res.data.response.registration == true) {
            this.applicationNotSubmitted = false;
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response.data.error.message);
          }
        });
    },
    getContactDetail() {
      var token = this.userData.token;
      //   var token = localStorage.getItem('token');
      var config = {
        headers: { Authorization: 'Bearer ' + token },
      };
      if (token) {
        axios
          .get('user/' + this.userData.id, config)
          .then((res) => {
            if (res.status == 200) {
              this.userStatus = res.data.response.status;
              this.contactInfoForm = res.data.response;

              // If invited for mentorship
              if( this.contactInfoForm.user_type_id == 4 && this.contactInfoForm.is_invited == 1 && this.contactInfoForm.is_upgraded == 0 && this.contactInfoForm.is_applied == 0 ) {
                  router.push({ name: 'mentor-background-check'});
              } else {
                if (this.enableConditions == true) {
                  // console.log(this.userStatus);

                  if (this.userStatus == 1) {
                    router.push({ name: 'profile' });
                  } else {
                    if (this.applicationNotSubmitted == false) {
                      console.log(this.userStatus);
                      router.push({ name: 'thankyou' });
                    }
                  }
                }
              }

              
            }
          })
          .catch((err) => {
            if (err.response) {
              console.log(err.response.data.error.message);
              if (err.response.status == 401) {
                // this.logout();
              }
            }
          });
      }
    },
    addAssignment() {
      if (this.userRoles) {
        var roles_length = this.userRoles.length;

        if (roles_length > 0) {
          var role_id = this.userRoles[0] ? this.userRoles[0] : 0;
          var formData = new FormData();
          var userData = JSON.parse(localStorage.getItem('web_user'));
          var volunteers = [userData['id']];
          // formData.append('user_id',userData['id']);
          formData.append('user_type_id', userData['user_type_id']);
          formData.append('location_id', userData['location_id']);
          // formData.append('building_id',"")
          // formData.append('department_id',"")
          formData.append('role_id', role_id);
          formData.append('volunteers', volunteers);
          // formData.append('approver_id',1)
          // formData.append('started_at',moment('0000-00-00','YYYY-MM-DD').format('YYYY-MM-DD'))
          // formData.append('ended_at',moment('0000-00-00','YYYY-MM-DD').format('YYYY-MM-DD'))
          formData.append('status', 'awaiting_approval');

          formData.append('days[]', 'someday');
          formData.append('time' + '[someday]' + '[start]', '');
          formData.append('time' + '[someday]' + '[end]', '');

          var token = userData['token'];
          var config = {
            headers: {
              Authorization: 'Bearer ' + token,
              Accept: 'application/json',
            },
          };
          if (token) {
            axios
              .post('user/assignments', formData, config)
              .then((res) => {
                localStorage.removeItem('selectedRoles');
                console.log(res.data.response);
              })
              .catch((err) => {
                if (err.response) {
                  console.log(err.response);
                }
              });
          }
        } //if role is selected
      } //if having user roles
    },

    gotoRoles() {
      router.push({ name: 'volunteer-roles' });
    },
    gotoMentorHours() {
      router.push({ name: 'mentor-hours' });
    },
    loginPage() {
      router.push({ name: 'login' });
    },
    gotoProfile() {
      router.push({ name: 'profile' });
    },
    gotoApplication() {
      router.push({ name: 'review-application' });
    },
    contactt() {
      router.push({ name: 'contact'})
    },
  },
};
</script>

<template>
  <div>
    <Header></Header>
    <div id="main-title" class="secondary">
      <div class="container">
        <div class="row mx-0">
          <div class="col-12 col-lg-6 align-self-center">
            <h3 class="title" v-if="userData.is_mentor">
              Mentor / Volunteer Details
            </h3>
            <h3 class="title" v-else>
              {{ userData['user_type_id'] === 3 ? 'Mentor' : 'Volunteer' }}
              Application
            </h3>
          </div>
          <div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
            <p class="need-help">
              Need Help ? <a @click="contactt" href="javascript:">Contact Us</a>
            </p>
            <!--              <logout-button></logout-button>-->
          </div>
        </div>
      </div>
    </div>

    <div
      class="custom-form d-flex container pb-5 pt-5"
      v-if="!enableConditions"
    >
      <b-button class="btn-custom ms-0" variant="custom" @click="gotoProfile">
        Profile Information
      </b-button>
      <b-button
        v-if="userData['user_type_id'] === 4"
        class="btn-custom"
        variant="custom"
        @click="gotoRoles"
      >
        Roles
      </b-button>
      <b-button
        v-else
        class="btn-custom"
        variant="custom"
        @click="gotoMentorHours"
      >
        Mentor Hours
      </b-button>
      <b-button class="btn-custom" variant="custom" @click="gotoApplication">
        Review Application
      </b-button>
    </div>

    <div id="create-account">
      <div class="container">
        <form class="custom-form">
          <div class="row mx-0">
            <div class="col-12 mb-5">
              <h3 class="main-title">Review Application</h3>
            </div>
            <div v-show="isShow" class="alert alert-danger col-12">
              <span
                class="d-block"
                v-for="(error, index) in errors"
                :key="index"
                >- {{ error }}</span
              >
            </div>
          </div>

          <!-- volunteer block -->
          <div class="row mx-0" v-if="userData['user_type_id'] === 4 && !userData.is_mentor">
            <div class="col-12 col-md-3">
              <b-button @click="personalInformation" variant="review">
                <i
                  class="bx bx-check"
                  :class="{ selected: isPersonalInfo }"
                ></i>
                Contact Information
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div class="col-12 col-md-3">
              <b-button @click="questions" variant="review">
                <i class="bx bx-check" :class="{ selected: isQuestion }"></i>
                Applicant History
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div
              class="col-12 col-md-3"
              v-if="userData['user_type_id'] === 3 || userData.is_mentor"
            >
              <b-button @click="backgroundCheck" variant="review">
                <i class="bx bx-check" :class="{ selected: isBackground }"></i>
                Background Check
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div class="col-12 col-md-3">
              <b-button @click="faith" variant="review">
                <i class="bx bx-check" :class="{ selected: isFaith }"></i>
                Faith Journey
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div
              class="col-12 col-md-3"
              v-if="userData['user_type_id'] === 3 || userData.is_mentor"
            >
              <b-button @click="references" variant="review">
                <i class="bx bx-check" :class="{ selected: isReference }"></i>
                References
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <!-- <div
              class="col-12 col-md-3"
              v-if="userData['user_type_id'] === 3 || userData.is_mentor"
            >
              <b-button @click="employment" variant="review">
                <i class="bx bx-check" :class="{ selected: isEmployment }"></i>
                Employment
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div> -->
            <div class="col-12 col-md-3">
              <b-button @click="additionalDetails" variant="review">
                <i class="bx bx-check" :class="{ selected: isAdditional }"></i>
                Interests, Skills, Involvement
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div class="col-12 col-md-3" v-if="userData['user_type_id'] === 4">
              <b-button @click="opportunities" variant="review">
                <i
                  class="bx bx-check"
                  :class="{ selected: isOpportunities }"
                ></i>
                Opportunities
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
          </div>

          <!-- Mentor block -->
          <div class="row mx-0" v-if="userData['user_type_id'] === 3">
            <div class="col-12 col-md-3">
              <b-button @click="personalInformation" variant="review">
                <i
                  class="bx bx-check"
                  :class="{ selected: isPersonalInfo }"
                ></i>
                Contact Information
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>

            <div
              class="col-12 col-md-3"
              v-if="userData['user_type_id'] === 3 || userData.is_mentor"
            >
              <b-button @click="backgroundCheck" variant="review">
                <i class="bx bx-check" :class="{ selected: isBackground }"></i>
                Background Check Information
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>

            <div class="col-12 col-md-3">
              <b-button @click="questions" variant="review">
                <i class="bx bx-check" :class="{ selected: isQuestion }"></i>
                Applicant History
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>

            <div class="col-12 col-md-3">
              <b-button @click="faith" variant="review">
                <i class="bx bx-check" :class="{ selected: isFaith }"></i>
                Faith Journey
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div class="col-12 col-md-3">
              <b-button @click="additionalDetails" variant="review">
                <i class="bx bx-check" :class="{ selected: isAdditional }"></i>
                Interests, Skills, Involvement
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div
              class="col-12 col-md-3"
              v-if="userData['user_type_id'] === 3 || userData.is_mentor"
            >
              <b-button @click="references" variant="review">
                <i class="bx bx-check" :class="{ selected: isReference }"></i>
                Character Reference
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <!-- <div class="col-12 col-md-3" v-if="userData['user_type_id'] === 3 || userData.is_mentor">
              <b-button @click="employment" variant="review">
                <i class="bx bx-check"
                   :class="{ 'selected': isEmployment }"></i>
                Employment
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div> -->
            <!-- <div class="col-12 col-md-3" v-if="userData['user_type_id'] === 4">
              <b-button @click="opportunities" variant="review">
                <i class="bx bx-check"
                   :class="{ 'selected': isOpportunities }"></i>
                Opportunities
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div> -->
          </div>

          <!-- Mentor/Volunteer block -->
          <div class="row mx-0" v-if="userData['user_type_id'] === 4 && userData.is_mentor">
            <div class="col-12 col-md-3">
              <b-button @click="personalInformation" variant="review">
                <i
                  class="bx bx-check"
                  :class="{ selected: isPersonalInfo }"
                ></i>
                Contact Information
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>

            <div
              class="col-12 col-md-3"
              v-if="userData['user_type_id'] === 3 || userData.is_mentor"
            >
              <b-button @click="backgroundCheck" variant="review">
                <i class="bx bx-check" :class="{ selected: isBackground }"></i>
                Background Check Information
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>

            <div class="col-12 col-md-3">
              <b-button @click="questions" variant="review">
                <i class="bx bx-check" :class="{ selected: isQuestion }"></i>
                Applicant History
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>

            <div class="col-12 col-md-3">
              <b-button @click="faith" variant="review">
                <i class="bx bx-check" :class="{ selected: isFaith }"></i>
                Faith Journey
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div class="col-12 col-md-3">
              <b-button @click="additionalDetails" variant="review">
                <i class="bx bx-check" :class="{ selected: isAdditional }"></i>
                Interests, Skills, Involvement
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div
              class="col-12 col-md-3"
              v-if="userData['user_type_id'] === 3 || userData.is_mentor"
            >
              <b-button @click="references" variant="review">
                <i class="bx bx-check" :class="{ selected: isReference }"></i>
                Character Reference
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
            <div class="col-12 col-md-3">
              <b-button @click="opportunities" variant="review">
                <i
                  class="bx bx-check"
                  :class="{ selected: isOpportunities }"
                ></i>
                Opportunities
                <a href="javascript:" class="rvw-link">Review</a>
              </b-button>
            </div>
          </div>

          <div class="row mx-0 justify-content-center">
            <div class="col-12 col-md-6">
              <!-- <div class="mt-5">
                <p class="sub-title">
                  You may submit your information for registration, please note
                  that you can update your information at any time.
                </p>
              </div> -->
              <!-- v-if="applicationNotSubmitted" -->
              <div class="text-center mt-3" v-if="applicationNotSubmitted">
                <b-button
                  :class="isDisable ? 'pe-none bg-secondary bg-soft' : ''"
                  :disabled="isDisable"
                  variant="custom"
                  @click="submitApplication"
                >
                  Submit Application
                </b-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <Footer></Footer>
    <b-modal
      id="mentorApplicationComplete"
      centered
      size="lg"
      title="Your application has been submitted!"
      title-class="font-18"
      hide-footer
    >
      <div class="row mx-0">
        <div class="col-12">
          <p class="pb-0">
            Thank you for completing your application to become MNTC mentor. A
            member of our team will be reaching out to you directly if you are
            selected or if we need additional information.
          </p>
          <h4 class="fw-bold mb-3 mt-4 text-start">What to Expect?</h4>
          <p class="mt-2 text-start pb-0">
            We will communicate acceptance or rejection of you application with
            X Business Days
          </p>
          <p class="mt-2 text-start pb-0">
            We will be connecting with your references listed in the application
          </p>
          <p class="mt-2 text-start pb-0">
            All applicants will be subject to a background check
          </p>
          <p class="mt-2 text-start pb-0">
            If accepted, we will reach out to schedule orientation with the MNTC
            team
          </p>
          <div class="d-flex justify-content-center mb-5">
            <b-button
              type="button"
              @click="$bvModal.hide('mentorApplicationComplete')"
              variant="custom"
              >Visit MNTC.ORG</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
